var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCorrectAnswer = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 13,
  viewBox: "0 0 16 13",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.4067 3.43885L7.35507 11.4455C6.9772 11.8203 6.46768 12.0309 5.93493 12.0309H5.93339C5.39599 12.0294 4.88493 11.8157 4.5086 11.4362L0.584248 7.4871C-0.197835 6.69882 -0.194737 5.42581 0.59354 4.64217C1.38027 3.85699 2.65638 3.86164 3.44001 4.65147L5.94423 7.17272L12.5695 0.586184C13.3562 -0.198996 14.6308 -0.19435 15.4144 0.593928C16.198 1.38066 16.1949 2.65677 15.4067 3.43885Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCorrectAnswer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/correct-answer.43218b9d823233c08c38b5ba23ca8e83.svg";